"use client";

import { animated, useInView } from "@react-spring/web";
import Image from "next/image";
import { Balancer } from "react-wrap-balancer";

import { useLang } from "@/hooks/use-lang";

export const IntroductionSection = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const TechnologyImage = animated(Image as any);
  const [ref, springs] = useInView(
    () => ({
      from: { opacity: 0, translateY: -300 },
      to: { opacity: 1, translateY: 0 },
      config: { duration: 1500 },
    }),
    { once: true, amount: "all" }
  );
  const { t } = useLang();

  return (
    <div className="bg-[#fcfcfc]">
      <div className="m-auto box-content flex max-w-[1280px] flex-col items-center justify-center px-[30px] pt-16 md:flex-row">
        {/* image animation section */}
        <TechnologyImage
          src="/technology/main2.webp"
          alt="technology img"
          width={300}
          height={300}
          ref={ref}
          style={{ ...springs }}
          aria-label="introduction section image"
          className="unselectable -mb-[150px] hidden shrink-0 object-contain drop-shadow-[0_80px_0_#fcfcfc] md:block lg:h-[400px] lg:w-[400px] xl:-mb-[100px] xl:h-[541px] xl:w-[541px]"
        />
        {/* text section */}
        <div className="flex flex-col justify-center pl-0 md:pl-[4%] lg:pl-[10%]">
          <Description
            title={t.technology.introductionSection[0]}
            content={t.technology.introductionSection[1]}
          />
          <Description
            title={t.technology.introductionSection[2]}
            content={t.technology.introductionSection[3]}
          />
        </div>
      </div>
      <div className="bg-[#09364b] md:h-[180px]" />
    </div>
  );
};

const Description = ({
  title,
  content,
}: {
  title: string;
  content: string;
}) => (
  <div className="w-full pb-10 md:pb-20">
    <h2
      className="border-b-[9px] border-b-[#00BC75] pb-6 font-bold sm:text-xl md:text-2xl lg:text-3xl"
      aria-label="introduction section title"
    >
      <Balancer>{title}</Balancer>
    </h2>
    <p className="mt-5 text-sm leading-loose sm:text-base md:text-lg">
      <Balancer>{content}</Balancer>
    </p>
  </div>
);
